import CalendarOutlined from "@ant-design/icons/CalendarOutlined";
import HomeOutlined from "@ant-design/icons/HomeOutlined";
import MedicineBoxOutlined from "@ant-design/icons/MedicineBoxOutlined";
import SettingOutlined from "@ant-design/icons/SettingOutlined";
import WarningOutlined from "@ant-design/icons/WarningOutlined";
import type { JSX } from "react";

import Dashboard from "./Dashboard";
import IssueTracker from "./IssueTracker";
import { LocationsMapScreen } from "./LocationsMap";
import Appointments from "./PastAndFutureAppointments";
import Products from "./Products";
import UpdateLocationScreen from "./UpdateLocation";
import UserSettings from "./UserSettings";

interface RouteDefinition {
  element: JSX.Element;
  icon?: JSX.Element;
  path: string;
  title: JSX.Element | string;
}

export const routes: RouteDefinition[] = [
  { element: <Dashboard />, icon: <HomeOutlined />, path: "/", title: "Startpagina" },
  { element: <LocationsMapScreen />, path: "locations", title: "Locaties" },
  { element: <UpdateLocationScreen />, path: "locations/:locationId/edit", title: "Locatie bewerken" },
  //  { element: <SalesInvoices />, icon: <AccountBookOutlined />, path: "invoices", title: "Facturen" },
  { element: <Appointments />, icon: <CalendarOutlined />, path: "appointments", title: "Onderhoudsbeurten" },
  { element: <Products />, icon: <MedicineBoxOutlined />, path: "products", title: "Veiligheidsmiddelen" },
  { element: <IssueTracker />, icon: <WarningOutlined />, path: "issues", title: "Berichten" },
  { element: <UserSettings />, icon: <SettingOutlined />, path: "settings", title: "Accountinstellingen" },
];
